export default {
	ASSOCIATED_INGREDIENTS: 'Associated ingredients',
	PRODUCT_VARIANT_INGREDIENT_VARIATIONS:
		'Product variant ingredient variations',
	INGREDIENT_ASSOCIATED_DISCOUNTS: 'Ingredient associated discounts',
};
